import React from 'react'
import { Icon } from '@iconify/react'
import styles from './ProjectHealthDashboard.module.css'
import { formatHours } from './reports.utils'

const METRICS = [
    {
        key: 'estimated',
        label: 'Total estimated',
        icon: 'mdi:clock-outline',
        tone: 'indigo',
        field: 'totalEstimatedHours',
    },
    {
        key: 'logged',
        label: 'Total logged',
        icon: 'mdi:timer-outline',
        tone: 'sky',
        field: 'totalLoggedHours',
    },
    {
        key: 'variance',
        label: 'Variance',
        icon: 'mdi:chart-timeline-variant',
        tone: 'amber',
        computed: true,
    },
    {
        key: 'members',
        label: 'Team members',
        icon: 'mdi:account-group-outline',
        tone: 'slate',
        members: true,
    },
]

const HealthMetricCards = ({ data }) => {
    const estimated = Number(data?.totalEstimatedHours) || 0
    const logged = Number(data?.totalLoggedHours) || 0
    const variance = logged - estimated
    const memberCount = Array.isArray(data?.members)
        ? data.members.length
        : 0
    const utilization =
        estimated > 0 ? Math.round((logged / estimated) * 100) : 0

    const values = {
        totalEstimatedHours: `${formatHours(estimated)}h`,
        totalLoggedHours: `${formatHours(logged)}h`,
        variance: `${variance >= 0 ? '+' : ''}${formatHours(variance)}h`,
        members: String(memberCount),
    }

    return (
        <div className={styles.metricsGrid}>
            {METRICS.map((metric) => (
                <div
                    key={metric.key}
                    className={`${styles.metricCard} ${styles[`metricCard_${metric.tone}`]}`}
                >
                    <div className={styles.metricIconWrap}>
                        <Icon icon={metric.icon} width={20} height={20} />
                    </div>
                    <div className={styles.metricBody}>
                        <span className={styles.metricLabel}>
                            {metric.label}
                        </span>
                        <span className={styles.metricValue}>
                            {metric.members
                                ? values.members
                                : metric.computed
                                  ? values.variance
                                  : values[metric.field]}
                        </span>
                    </div>
                </div>
            ))}
            <div className={styles.utilizationCard}>
                <div className={styles.utilizationHeader}>
                    <span className={styles.utilizationLabel}>
                        Logged vs estimated
                    </span>
                    <span className={styles.utilizationValue}>
                        {utilization}%
                    </span>
                </div>
                <div className={styles.utilizationTrack}>
                    <div
                        className={styles.utilizationFill}
                        style={{
                            width: `${Math.min(utilization, 100)}%`,
                        }}
                    />
                    {utilization > 100 && (
                        <div
                            className={styles.utilizationOverflow}
                            style={{
                                width: `${Math.min(utilization - 100, 40)}%`,
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default HealthMetricCards
